import React, { Component } from 'react';
import Abook from './index';
import ErrorBoundary from '../../../components/ErrorBoundary';

const ImportAbookContacts = React.lazy(() => import('./ImportAbookContacts'));

class AbookManageImportPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Abook scrolling>
        <ErrorBoundary>
          <React.Suspense fallback={<div />}>
            <ImportAbookContacts />
          </React.Suspense>
        </ErrorBoundary>
      </Abook>
    );
  }
}
export default AbookManageImportPage;
